import { readToken } from "./session";
import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((cfg) => {
  const token = readToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  // PERF-MINI-03/03b: Lese-Anfragen (GET) erhalten eine Obergrenze gegen endloses Hängen.
  // Axios merged config.timeout bereits VOR den Interceptors auf den Default 0 (keine
  // Begrenzung) — daher hier auf "falsy" statt nur "undefined" prüfen. Schreibanfragen
  // (POST/PUT/PATCH/DELETE), Downloads/Exporte (responseType "blob") und jeder bereits
  // explizit gesetzte positive Timeout am einzelnen Aufruf bleiben unverändert.
  const method = (cfg.method || "get").toLowerCase();
  if (method === "get" && cfg.responseType !== "blob" && !cfg.timeout) {
    cfg.timeout = 30000;
  }
  return cfg;
});

export function formatApiError(err) {
  if (err?.code === "ECONNABORTED" || /timeout/i.test(err?.message || "")) {
    return "Zeitüberschreitung — die Anfrage hat zu lange gedauert. Bitte erneut versuchen.";
  }
  const detail = err?.response?.data?.detail;
  if (!detail) return err.message || "Etwas ist schiefgelaufen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail === "object" && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export default api;

let isolatedPreview = false;
const previewListeners = new Set();
export function watchPreviewIsolation(listener) {
  previewListeners.add(listener); listener(isolatedPreview);
  return () => previewListeners.delete(listener);
}
api.interceptors.response.use((response) => {
  const isolated = response.headers?.['x-warenpro-isolated-review'] === 'true';
  if (isolated !== isolatedPreview) {
    isolatedPreview = isolated;
    previewListeners.forEach((listener) => listener(isolated));
  }
  return response;
});
